export const getSaturnIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88367 3.5837C11.7505 2.25381 13.2751 1.66291 13.8061 2.1939C14.3371 2.72489 13.7462 4.2495 12.4163 6.11635M12.4163 6.11635C11.6614 7.17607 10.6683 8.34607 9.5072 9.5072C8.34607 10.6683 7.17606 11.6614 6.11634 12.4163M12.4163 6.11635C12.6633 6.69467 12.8 7.3314 12.8 8C12.8 10.651 10.651 12.8 8 12.8C7.3314 12.8 6.69466 12.6633 6.11634 12.4163M3.5837 9.88367C2.2538 11.7505 1.66291 13.2751 2.19389 13.8061C2.72489 14.3371 4.2495 13.7462 6.11634 12.4163M11.3941 4.60589C10.5255 3.73726 9.32547 3.2 8 3.2C5.34903 3.2 3.2 5.34904 3.2 8C3.2 9.32547 3.73726 10.5255 4.60589 11.3941"
        stroke="#373cf1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const getNowTextFromJson = (now) => {
  return (
    <p className="now-item">
      {now.text}
      {now.url ? (
        <a
          href={now.url}
          className="now-item-url"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          {now.urlText}.
        </a>
      ) : null}
    </p>
  );
};

export const getCarousalLeftArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" fill="#373cf1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.795 7.23501C14.9315 7.37957 15.0051 7.57245 14.9995 7.77122C14.9938 7.97 14.9095 8.1584 14.765 8.29501L10.842 12L14.765 15.705C14.9047 15.8427 14.9849 16.0297 14.9884 16.2258C14.9919 16.422 14.9184 16.6117 14.7836 16.7543C14.6489 16.8968 14.4637 16.981 14.2676 16.9886C14.0716 16.9962 13.8804 16.9267 13.735 16.795L9.235 12.545C9.16086 12.4749 9.10179 12.3904 9.06143 12.2967C9.02106 12.203 9.00024 12.102 9.00024 12C9.00024 11.898 9.02106 11.797 9.06143 11.7033C9.10179 11.6096 9.16086 11.5251 9.235 11.455L13.735 7.20501C13.8796 7.06846 14.0724 6.99492 14.2712 7.00054C14.47 7.00617 14.6584 7.09051 14.795 7.23501Z"
        fill="white"
      />
    </svg>
  );
};

export const getCarousalRightArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" fill="#373cf1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.205 16.765C9.06845 16.6204 8.99491 16.4276 9.00053 16.2288C9.00616 16.03 9.0905 15.8416 9.235 15.705L13.158 12L9.235 8.29499C9.09529 8.15728 9.01509 7.97031 9.01161 7.77417C9.00813 7.57802 9.08163 7.38832 9.21637 7.24574C9.35111 7.10315 9.53634 7.01903 9.73237 7.01142C9.9284 7.0038 10.1196 7.07329 10.265 7.20499L14.765 11.455C14.8391 11.5251 14.8982 11.6096 14.9386 11.7033C14.9789 11.797 14.9998 11.898 14.9998 12C14.9998 12.102 14.9789 12.203 14.9386 12.2967C14.8982 12.3904 14.8391 12.4749 14.765 12.545L10.265 16.795C10.1204 16.9315 9.92756 17.0051 9.72879 16.9995C9.53001 16.9938 9.34161 16.9095 9.205 16.765Z"
        fill="white"
      />
    </svg>
  );
};
